/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { ControlledCustomSelect } from "../../../components/formsComponents";
import { api } from "../../../api/api";
import { IDrivedExternalLeadStatus } from "../../../redux/external-leads/external-leads-life-cycle/external-lead-status.types";
import { useBillingCompanyContext } from "../../../providers";

export interface IExtLeadStatusSearchProps {
  value: string | null;
  onChange: (value: IDrivedExternalLeadStatus | null) => void;
  error?: string;
  statusName?: string;
  placeholder?: string;
}

export const ExtLeadStatusSearch: React.FC<IExtLeadStatusSearchProps> = (
  props,
) => {
  const { value, error, onChange, statusName, placeholder } = props;
  const companyOutlet = useBillingCompanyContext();
  const [options, setOptions] = React.useState<IDrivedExternalLeadStatus[]>([]);

  const fetchSuggestion = async () => {
    try {
      const res = await api.get(
        `/dataManagement/get-drive-external-status?company_outlet_uuid=${companyOutlet.comapny.company_outlet_uuid}`,
      );
      const data: IDrivedExternalLeadStatus[] = res.data.data || [];
      setOptions(data);
    } catch (error) {
      console.error("Error fetching external lead status list:", error);
    }
  };

  useEffect(() => {
    fetchSuggestion();
  }, []);

  return (
    <>
      <ControlledCustomSelect
        label="Status"
        labelId="ext-lead-status-search"
        fullWidth
        placeholder={placeholder}
        clearable={!!value}
        sx={{
          minWidth: "120px",
        }}
        displayEmpty
        value={value || ""}
        options={(() => {
          const mapped = options.map((opt) => ({
            label: opt.name,
            value: opt.external_status_uuid || "",
          }));
          // If value exists but not found in options (e.g. options not loaded yet), inject a placeholder option
          if (value && !mapped.some((opt) => opt.value === value)) {
            mapped.unshift({ label: statusName || value, value });
          }
          return mapped;
        })()}
        renderValue={(selected) => {
          if (!selected) return "Select Status";
          const found = options.find(
            (opt) => opt.external_status_uuid === selected,
          );
          return found?.name || statusName || (selected as string);
        }}
        onChange={(e) => {
          const selected = options.find(
            (opt) => opt.external_status_uuid === e.target.value,
          );
          onChange(selected || null);
        }}
        onClear={() => onChange(null)}
        error={!!error}
        helperText={typeof error === "string" ? error : ""}
      />
    </>
  );
};
